import {
    SET_HIGHLIGHTED_FEATURES,
    HIGHLIGHT_FEATURES,
    UNHIGHLIGHT_FEATURES
} from './Types';
import { HighlightedFeature } from './highlightsTypes';

export const setHighlightedFeatures = (highlights:HighlightedFeature[]) => ({ type: SET_HIGHLIGHTED_FEATURES, highlights }); // Set
export const highlightFeatures = (highlights:HighlightedFeature[]) => ({ type: HIGHLIGHT_FEATURES, highlights }); // Additive
export const unhighlightFeatures = (highlights:HighlightedFeature[]) => ({ type: UNHIGHLIGHT_FEATURES, highlights }); // Subtractive